import { render, staticRenderFns } from "./PrivacyData.vue?vue&type=template&id=486c3c8d&"
import script from "./PrivacyData.vue?vue&type=script&lang=js&"
export * from "./PrivacyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports